<div class="row mx-0 mb-3 pb-1">
  <div class="col-12 pl-0">
       <span class="sg-section-title sg-ref-section"> Reference Documents</span>
      <button class="mat-primary mat-raised-button sg-primary-button"
      (click)="onDocumentsClick()"> Shared Documents</button>

      <button class="mat-primary mat-stroked-button sg-primary-stroked ml-5"
       matTooltip="Only available for Suppliers with access to Project Link application"
       tooltipclass="tooltip-feedback" (click)="activateProjectLink()">
       Project Link</button>
  </div>

</div>
<section>
  <div class="row mx-0 pr-1">
    <form [formGroup]="searchTypeForm"> 
      <mat-accordion class="w-100">
          <ng-container *ngFor="let item of pageContents">
          <mat-expansion-panel class="mb-2"
          (opened)="panelOpenState = true" (closed)="panelOpenState = false" *ngIf="!(item.sectionHeader === 'Supplier Onboarding Information' && !isInternalUsers)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{item.sectionHeader}}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mx-0 pt-3">
              <p [innerHTML]="item.sectionDescription"></p>
            </div>
            <div class="row mx-0 pt-3">
              <div>
                  <p class="sg-read-more mb-1">
                    <a target="_blank" *ngIf="item.sectionHeader == 'Compliance and Regulations'" (click)="onComplianceRegulations()">Read More ...</a>
                  </p>
                  <p class="sg-read-more mb-1" *ngFor="let links of item.links">
                    <a *ngIf="links.linkType == 'Document'"  target="_blank" (click)="getLogData(links.linkAddress, item.sectionHeader, 'View', links.linkType)">{{links.linkTitle}}</a>
                    <a [href]="links.linkAddress" target="_blank" *ngIf="links.linkType == 'URL'" (click)="getLogData(links.linkTitle, item.sectionHeader,'View', links.linkType)">{{links.linkTitle}}</a>
                  </p>
              </div>
          </div>
          </mat-expansion-panel>
          </ng-container>
          
          <mat-expansion-panel class="mb-2" (opened)="panelOpenState = true"
                               (closed)="panelOpenState = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Helpful Documentation
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mx-0 pt-3">
                <div class="col-5 px-0 sg-search-es">
                  <label class="sg-form-field-label mr-2">Search</label>
                  <mat-form-field appearance="outline" class="w-25 sg-searchType-es">
                      <mat-select placeholder="ES Spec" formControlName="searchTypeCtrl" (selectionChange) ="onChangeOption($event.value.id)"  class="sg-select-sup">
                        <mat-option *ngFor="let item of searchTypeOption" [value]="item.id">
                          {{item.value}}
                        </mat-option>
                      </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-50">
                 <input  matInput type="text" name="user" formControlName="searchTextBoxCtrl" id="search" appSharedDirective>
                  </mat-form-field>
                  <mat-error class="d-flex justify-content-end mr-5 pr-5" *ngIf="showErrmessage">Format for ES search is not correct.</mat-error>
                  <mat-error class="d-flex justify-content-end mr-5 pr-5" *ngIf="showErrormessage">This is required field.</mat-error>
                </div>
                <div class="col-2" style="padding-top: 3px">
                  <button class="mat-primary mat-raised-button export-button" mat-raised-button
                  (click)="onSearchClick()">Search</button>
                </div>
                <div class="col-5 px-0">
                  <div class="row mx-0 w-100" *ngIf="searchResultFlag">
                    <!-- <div class="pl-2 pl-1 pt-2 sg-form-field-label d-flex justify-content-end" *ngIf="!searchResultNotFound">
                      <span>Result: {{windchillFileInfo.fileName}}</span>
                    </div> -->
                    <div class="col-10 pl-0 pl-1 pt-2 sg-form-field-label d-flex" *ngIf="searchResultNotFound">
                      <span>{{windchillFileInfo}}</span>
                    </div>
                    <!-- <div class="col-1 pl-1 pr-0 pointer-cursor" *ngIf="!searchResultNotFound">
                        <i class="material-icons pt-1" (click)="onDownloadClick()">download</i>
                    </div> -->
                  </div>
                </div>

            </div>

          </mat-expansion-panel>
         
      </mat-accordion>
     </form>
  </div>
  <div style="height:70px;">&nbsp;</div>
</section>

<div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
  <mat-spinner></mat-spinner>
</div>